import _ from "lodash"

export const getExtraWithID = extraID => state => {
  const possibleExtras = getExtrasForSelectedPhone(state)

  return possibleExtras[extraID]
}

export const getExtrasForSelectedPhone = state => {
  // get the selected phone from the basket store
  // const selectedPhoneID = state.basket.phoneID;
  const { planID: selectedPlanID, phoneID: selectedPhoneID } = state.basket

  let extrasForPhone = getExtrasForGivenPhoneAndPlan(
    selectedPhoneID,
    selectedPlanID
  )(state)

  if (state.plans.options.excludeVAT) {
    extrasForPhone = _.cloneDeep(extrasForPhone)
    Object.keys(extrasForPhone).map(
      extraName =>
        (extrasForPhone[extraName].cost =
          extrasForPhone[extraName].cost / state.plans.options.vatDivider)
    )
  }

  return extrasForPhone
}

export const getExtrasForGivenPhoneAndPlan = (
  selectedPhoneID,
  selectedPlanID
) => state => {
  const { condition: selectedConditionID } = state.condition

  // Grab the global extras that should be displayed for every phone
  let extrasForPhone = _.cloneDeep(state.extras.byID)

  // Include/Exclude based on device
  extrasForPhone = includeAndExcludeExtras(
    state.extras.byDevice,
    extrasForPhone,
    "devices",
    selectedPhoneID
  )

  // Include/Exclude based on plan
  extrasForPhone = includeAndExcludeExtras(
    state.extras.byPlan,
    extrasForPhone,
    "plans",
    selectedPlanID
  )

  // Include/Exclude based on condition
  extrasForPhone = includeAndExcludeExtras(
    state.extras.byCondition,
    extrasForPhone,
    "conditions",
    selectedConditionID
  )

  // Include/Exclude based on plan and device
  extrasForPhone = includeAndExcludeExtras(
    state.extras.byPlanAndDevice,
    extrasForPhone,
    "planAndDevices",
    [selectedPlanID, selectedPhoneID]
  )

  return extrasForPhone
}

// Helper function to include and exclude extras based on some attribute
function includeAndExcludeExtras(
  extrasObject,
  outputExtras,
  filterVarName,
  filterValue
) {
  let filteredExtras

  // Check if the fitlerValue is an Array or not to call the appropriate function
  if (Array.isArray(filterValue)) {
    filteredExtras = extrasObject.filter(extra =>
      arrayContainsArray(extra[filterVarName], filterValue)
    )
  } else {
    filteredExtras = extrasObject.filter(extra =>
      _.includes(extra[filterVarName], filterValue)
    )
  }

  filteredExtras.forEach(additionalExtraObject => {
    additionalExtraObject.ADDITIONAL_EXTRAS &&
      Object.keys(additionalExtraObject.ADDITIONAL_EXTRAS).forEach(
        additionalExtraID =>
          (outputExtras[additionalExtraID] =
            additionalExtraObject.ADDITIONAL_EXTRAS[additionalExtraID])
      )
  })

  // Remove any excluded extras dictated by the condition
  filteredExtras.forEach(additionalExtraObject => {
    additionalExtraObject.EXCLUDED_EXTRAS &&
      additionalExtraObject.EXCLUDED_EXTRAS.forEach(excludedExtraID => {
        outputExtras = _.omit(outputExtras, excludedExtraID)
      })
  })

  return outputExtras
}

// Check if an array exists inside another
function arrayContainsArray(superset, subset) {
  return subset.every(value => {
    return superset.includes(value)
  })
}

// Get hybrid hub price
export const getHybridHubPrice = state => {
  return state.extras.byID["HYBRID_HUB"]
    ? state.extras.byID["HYBRID_HUB"].cost
    : 0
}

export const getWifiPrice = state => {
  return state.extras.byID["COMPLETE_WIFI"]
    ? state.extras.byID["COMPLETE_WIFI"].cost
    : 0
}

export const getAllExtras = state => {
  return state.extras.allIDs.map(
    extraID => state.extras.byID[extraID].shortText
  )
}
